import { render } from "./SessionLiveComponent.vue?vue&type=template&id=13097493&scoped=true"
import script from "./SessionLiveComponent.vue?vue&type=script&lang=js"
export * from "./SessionLiveComponent.vue?vue&type=script&lang=js"

import "./SessionLiveComponent.vue?vue&type=style&index=0&id=13097493&lang=scss&scoped=true"

import exportComponent from "/Users/apiffare/projects/aldes/apps/aldes-learning-support-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13097493"]])

export default __exports__